import React from 'react'
import { H4, Image } from '../../AbstractElements'
import { dynamicImage } from '../../Utils'
import { WadeWarren } from '../../Utils/Constants'
import SvgIcon from '../../Utils/CommonComponents/CommonIcons/CommonSvgIcons'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query';
import { fetchCurrentUserData } from '../../api/common'
export default function ProfileSection() {
    function navigateToapps() {
        navigate(`/organization-apps`);
    }
    const navigate = useNavigate();

    const { data, error, isLoading } = useQuery({ queryKey: ['fetchCurrentUserDataCache'], queryFn: fetchCurrentUserData, });


    return (
        <div className="profile-section sidebar-search">
            <div className="profile-wrapper">
                <div className="active-profile">
                    <Image className="img-fluid" src={dynamicImage(`user.png`)} alt="user" />
                    <div className="status bg-success"> </div>
                </div>
                <div>
                    <H4>{data?.data?.name}</H4>
                    <span>{data?.data?.email}</span>
                </div>
            </div>
            <div style={{ cursor: 'pointer' }} onClick={() => {
                navigateToapps()
            }}>
                <SvgIcon iconId='profile-setting' />
            </div>
        </div>
    )
}
